import Cookies from 'js-cookie';

import {
  ACCESS_TOKEN_KEY,
  IMPERSONATE_ACCESS_TOKEN_KEY,
  IMPERSONATE_REFRESH_TOKEN_KEY,
  REFRESH_TOKEN_KEY,
  STORAGE_ACCESS_TOKEN_KEY,
  STORAGE_IMPERSONATE_ACCESS_TOKEN_KEY,
  STORAGE_IMPERSONATE_REFRESH_TOKEN_KEY,
  STORAGE_REFRESH_TOKEN_KEY,
} from './constants';
import { cookieDomain } from './constants';

const removeLocalStorageToken = (key: string) => {
  if (globalThis.window !== undefined && key) localStorage.removeItem(key);
};

const removeSessionStorageToken = (key: string) => {
  if (globalThis.window !== undefined && key) sessionStorage.removeItem(key);
};

export const removeToken = (key: string) => {
  Cookies.remove(key, { domain: cookieDomain, path: '/', secure: true });

  switch (key) {
    case ACCESS_TOKEN_KEY:
      removeSessionStorageToken(STORAGE_ACCESS_TOKEN_KEY as string);
      break;
    case REFRESH_TOKEN_KEY:
      removeLocalStorageToken(STORAGE_REFRESH_TOKEN_KEY as string);
      break;
    case IMPERSONATE_ACCESS_TOKEN_KEY:
      removeSessionStorageToken(STORAGE_IMPERSONATE_ACCESS_TOKEN_KEY as string);
      break;
    case IMPERSONATE_REFRESH_TOKEN_KEY:
      removeLocalStorageToken(STORAGE_IMPERSONATE_REFRESH_TOKEN_KEY as string);
      break;
  }
};
